import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '~/components/JustificationContainer';
import { Heading5 } from '~/components/Typography/index';

type Props = { numberOfActions: number; label: string };

const StatisticsRow: React.FC<Props> = ({ numberOfActions, label }) => (
  <JustificationContainer align="center" gap="xxs">
    <StatisticsNumber
      align="center"
      justification="center"
      padding={['xxxs', 'xxs']}
    >
      <NumberOfActions>{numberOfActions}</NumberOfActions>
    </StatisticsNumber>
    <Heading withoutMargin fontWeight="regular">
      {label}
    </Heading>
  </JustificationContainer>
);

const Heading = styled(Heading5)(
  ({ theme }) => css`
    margin-top: ${theme.space('xxxs')};
  `,
);

const NumberOfActions = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.space('xxxs')};
  `,
);

const StatisticsNumber = styled(JustificationContainer)(
  ({ theme }) => css`
    border-radius: ${theme.getTokens().border.radius.s};
    background-color: ${theme.color('success', 'light')};
    color: ${theme.color('white')};
  `,
);

export default StatisticsRow;
